import React from 'react'
import { FaRegHandshake, FaGlobeAfrica, FaPeopleCarry, FaPiggyBank, FaUsersCog } from "react-icons/fa";

function Odometers() {
  return (
    <section className="odometer pb">
        <div className="container">
            <div className="row">
                <div className="item">
                    <div className="icon"><FaRegHandshake /></div>
                    <div className='__caption'><h4>Qualità dei lavori</h4></div>
                </div>
                <div className="item">
                    <div className="icon"><FaUsersCog /></div>
                    <div className='caption'><h4>Soddisfazione del cliente</h4></div>
                </div>
                <div className="item">
                    <div className="icon"><FaPiggyBank /></div>
                    <div className='caption'><h4>Rispetto dei costi preventivati</h4></div>
                </div>
                <div className="item">
                    <div className="icon"><FaGlobeAfrica /></div>
                    <div className='caption'><h4>Aspetti ambientali</h4></div>
                </div>
                <div className="item">
                    <div className="icon"><FaPeopleCarry /></div>
                    <div className='caption'><h4>Sicurezza sul lavoro</h4></div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Odometers